import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { GetYourGuideWidget } from "@/components/GetYourGuideWidget";
import { Seo } from "@/lib/seo";
import { useApp } from "@/context/AppContext";

export default function Experiences() {
  const { t } = useApp();
  return (
    <div className="min-h-screen overflow-x-hidden bg-sand" data-testid="experiences-page">
      <Seo
        title={t("detail.seo_exp_title")}
        description={t("detail.seo_exp_desc")}
        url={`${window.location.origin}/experiences`}
        image="https://umagobestprice.com/logo512.png"
      />
      <Navbar solid />
      <div className="mx-auto max-w-7xl px-5 pt-28 lg:px-8">
        <p className="overline text-terracotta">{t("detail.exp_overline")}</p>
        <h1 className="mt-3 font-serif text-4xl font-semibold text-petrol sm:text-5xl lg:text-6xl">
          {t("detail.exp_title")}
        </h1>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-petrol/70">
          {t("detail.exp_intro")}
        </p>
      </div>
      <div className="mx-auto max-w-7xl px-5 py-10 lg:px-8">
        <GetYourGuideWidget query="Umag, Croatia" items={16} />
      </div>
      <Footer />
    </div>
  );
}
